import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
class ResetPasswordGuardService {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean> | boolean {
    const urlParams = new URLSearchParams(location.search);
    const password_token = urlParams.get('reset_password_token') !== null ? urlParams.get('reset_password_token') : '';

    return new Observable<boolean | UrlTree>((observer) => {
      observer.next(!password_token.length ? this.router.parseUrl('/login') : true);
    });
  }
}

export const ResetPasswordGuard: CanActivateFn = (): Observable<boolean | UrlTree> | Promise<boolean> | boolean => {
  return inject(ResetPasswordGuardService).canActivate();
};
